// colors
import { Success, Error, Warning, Info } from "../colors";

export const MuiAlertComponent = {
    styleOverrides: {
        standardSuccess: {
            color: Success[25],
            backgroundColor: Success[95],
        },
        standardError: {
            color: Error[25],
            backgroundColor: Error[95],
        },
        standardWarning: {
            color: Warning[25],
            backgroundColor: Warning[95],
        },
        standardInfo: {
            color: Info[25],
            backgroundColor: Info[95],
        },
    },
};
